import React from "react";
import { TextField, Button } from "@mui/material";
import { Input } from "@mui/joy";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

const HandicapSetup = ({ formData, setFormData }) => {
    const handleFlightChange = (index, field, value) => {
        const newFlights = [...(formData.flights || [])];
        newFlights[index] = { ...newFlights[index], [field]: value };
        setFormData((prev) => ({ ...prev, flights: newFlights }));
    };

    const handleHandicapChange = (player, value) => {
        setFormData((prev) => ({
            ...prev,
            handicaps: { ...prev.handicaps, [player]: value }
        }));
    };

    const addFlight = () => {
        setFormData((prev) => ({
            ...prev,
            flights: [...(prev.flights || []), { name: "", min: "", max: "" }]
        }));
    };

    const removeFlight = (index) => {
        setFormData((prev) => ({ ...prev, flights: prev.flights.filter((_, i) => i !== index) }));
    };

    return (
        <div className="form-container">
            <h2>Handicap & Flight Setup</h2>
            <TextField
                label="Handicap Set Name"
                value={formData.handicapSetName || ""}
                onChange={(e) => setFormData((prev) => ({ ...prev, handicapSetName: e.target.value }))}
                fullWidth
                margin="normal"
            />
            <h3>Date Range</h3>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                    label="Start Date"
                    value={formData.startDate ? dayjs(formData.startDate) : null}
                    onChange={(date) => setFormData((prev) => ({ ...prev, startDate: date ? date.toDate() : null }))}
                    renderInput={(params) => <TextField {...params} className="styled-select" />}
                />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                    label="End Date"
                    value={formData.endDate ? dayjs(formData.endDate) : null}
                    onChange={(date) => setFormData((prev) => ({ ...prev, endDate: date ? date.toDate() : null }))}
                    renderInput={(params) => <TextField {...params} className="styled-select" />}
                />
            </LocalizationProvider>
            <h3>Enter Player Handicaps</h3>
            {(formData.players || []).map((player) => (
                <TextField
                    key={player}
                    label={`${player}'s Handicap`}
                    type="number"
                    value={formData.handicaps?.[player] || ""}
                    onChange={(e) => handleHandicapChange(player, e.target.value)}
                    fullWidth
                    margin="normal"
                />
            ))}
            <h3>Flight Groups</h3>
            {(formData.flights || []).map((flight, flightIndex) => (
                <div key={flightIndex} className="flight-entry">
                    <Input
                        placeholder="Flight Name"
                        value={flight.name}
                        onChange={(e) => handleFlightChange(flightIndex, "name", e.target.value)}
                        fullWidth
                        margin="normal"
                        endDecorator={<Button onClick={() => removeFlight(flightIndex)}><i className={'fi-rr-trash'}></i></Button>}
                    />
                    <TextField
                        label="Min Handicap"
                        type="number"
                        value={flight.start}
                        onChange={(e) => handleFlightChange(flightIndex, "min", e.target.value)}
                        margin="normal"
                    />
                    <TextField
                        label="Max Handicap"
                        type="number"
                        value={flight.end}
                        onChange={(e) => handleFlightChange(flightIndex, "max", e.target.value)}
                        margin="normal"
                    />
                </div>
            ))}
            <Button onClick={addFlight} variant={'contained'}>Add Flight</Button>
        </div>
    );
};

export default HandicapSetup;